import { Box, Group, Stack, Text, Title, Center } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { createFileRoute } from "@tanstack/react-router";
import { Page } from "@/components/page";
import { JoinNowButton } from "./-components/join-now-button";
import { EpicScreenShot } from "./-components/epic-screenshot";
import { ArtificalInstructorSection } from "./-components/artifical-instructor-section";
import { DeviceIntegrationCard } from "./-components/device-integration-card";
import { PornScrollerCard } from "./-components/porn-scroller-card";
import { TaskSection } from "./-components/task-section";

export const Route = createFileRoute("/_landing/_index/")({
  component: LandingPageRouteComponent,
});

function LandingPageRouteComponent() {
  const matches = useMediaQuery("(min-width: 800px)");

  return (
    <Page>
      <Center c="white">
        <Stack gap="xl" align="center" mt={matches ? 100 : 50}>
          <Box ta="center" maw={600}>
            <Title size="3.5rem" c="white" mb="xl" lh="4rem">
              The ultimate jerk-off experience
            </Title>
            <Text c="gray.5" mx="md">
              Fap Instructor is the ultimate jerk-off instruction experience.
              Fine tuned to your exact needs and wants.
            </Text>
          </Box>
          <Center>
            <JoinNowButton />
          </Center>
          <EpicScreenShot />
          <Stack gap="7rem" align="center">
            <ArtificalInstructorSection />
            <Group align="stretch" mx="md">
              <PornScrollerCard />
              <DeviceIntegrationCard />
            </Group>
          </Stack>
        </Stack>
      </Center>
      <TaskSection />
    </Page>
  );
}
